import reducer from './reducer'

import * as jobsOperations from './operations'
import * as jobsSelectors from './selectors'

export { jobsOperations, jobsSelectors }

export default reducer
